<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getToken, removeToken } from "@/utils/auth";
export default {
  name: "App",
  beforeCreate() {
    // 这里应该要处理一下
    if (!getToken()) {
      // 无 token，跳登录或不做事
      removeToken();
      //  清除权限
      localStorage.removeItem("user_permissions");
      if (this.$route.path !== "/login") {
        this.$router.push("/login");
      }
    }
  },
  created() {
     // 设置网页标题
    document.title = "第二民族幼儿园润芯管家管理系统";
    console.log("Token状态:", getToken());
    // if (getToken()) {
    //   console.log("发起请求");
    //   this.$store.dispatch("getCodeList");
    //   this.$store.dispatch("getDepartmentPage");
    //   this.$store.dispatch("getSupplierList");
    // }
  },
};
</script>

<style lang="scss">
#app {
  height: 100%;
  width: 100%;
}
.el-form-item__label {
  text-align: center !important;
}
</style>
